// extracted by mini-css-extract-plugin
module.exports = {"pageSidebarTitle":"PageSidebarTitle_pageSidebarTitle__T_C7k"};